import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

const KEY = 'app:lastRoute';

@Injectable({ providedIn: 'root' })
export class LastRouteService {
  constructor(private router: Router) {
    // Save after every successful navigation
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)) 
      .subscribe((e: any) => {
        const url = e.urlAfterRedirects || e.url || this.router.url;
        if(url!=='/login'){
        localStorage.setItem(KEY, url);
        }
      });

    // Also save when the tab closes or refreshes
    window.addEventListener('pagehide', () => {
      if(this.router.url!=='/login'){
      localStorage.setItem(KEY, this.router.url);
      }
    });
  }

  get(): string | null { return localStorage.getItem(KEY); }
  set(url: string) { localStorage.setItem(KEY, url); }
  clear() { localStorage.removeItem(KEY); }
}
